export const VerifiedIcon: React.FC<React.SVGAttributes<{}>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="42"
    viewBox="0 0 48 42"
    fill="none"
    {...props}
  >
    <path
      d="M20.1989 40.2076C30.2498 40.2076 38.3978 32.0597 38.3978 22.0087C38.3978 11.9577 30.2498 3.80981 20.1989 3.80981C10.1479 3.80981 2 11.9577 2 22.0087C2 32.0597 10.1479 40.2076 20.1989 40.2076Z"
      stroke="#197FDB"
      strokeWidth="3.60156"
      strokeMiterlimit="10"
    />
    <path
      d="M45.7585 1.31122L45.7577 1.3104C45.034 0.586688 43.8606 0.586687 43.1369 1.3104L19.0459 25.4013C18.3222 26.1251 18.3222 27.2984 19.0459 28.0221L19.0467 28.023C19.7705 28.7467 20.9438 28.7467 21.6675 28.023L45.7585 3.93202C46.4822 3.2083 46.4822 2.03493 45.7585 1.31122Z"
      fill="#197FDB"
    />
    <path
      d="M21.6585 28.0219L21.6593 28.0211C22.383 27.2974 22.383 26.124 21.6593 25.4003L14.1316 17.8726C13.4079 17.1489 12.2345 17.1489 11.5108 17.8726L11.51 17.8734C10.7863 18.5971 10.7863 19.7705 11.51 20.4942L19.0377 28.0219C19.7614 28.7456 20.9348 28.7456 21.6585 28.0219Z"
      fill="#197FDB"
    />
  </svg>
);
